export async function addHeader(requestObj, methodType) {
  const token = sessionStorage.getItem("admin_token");

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  // Add JWT authorization header
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const requestOptions = {
    method: methodType,
    headers,
    body: JSON.stringify(requestObj),
  };
  return requestOptions;
}

export async function addHeaderWithOutBody(methodType) {
  const token = sessionStorage.getItem("admin_token");

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  // Add JWT authorization header
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const requestOptions = {
    method: methodType,
    headers,
  };
  return requestOptions;
}
